import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Typography, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../context/AuthProvider';
import MenuIcon from '@mui/icons-material/Menu';
import PersonIcon from '@mui/icons-material/Person';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Swal from "sweetalert2";
import { CustomerHomeRightNav } from '../Nav/CustomerHomeRightNav';
import {ReactComponent as HomeIcon} from '../../assets/icons/HomeIcon.svg';
import { AppRoutes } from '../../helper/appRoutes';

export default function CustomerHomeLayout() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const [showRightNav, setShowRightNav] = useState(true);

  const logOut = () => {
    logout();
  };

  const handleHomeClick = () => {
    navigate(AppRoutes.client.base);
  };

  const toggleRightNav = () => {
    setShowRightNav(!showRightNav);
  };

  const handleProfileClick = () => {
    Swal.fire({
      title: 'Log Out',
      text: "Are you sure you want to log out?",
      showCancelButton: true,
      confirmButtonColor: '#02A4E3',
      cancelButtonColor: '#d33',
      customClass: 'logout-popup',
      // iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      iconHtml: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-power" viewBox="0 0 16 16"> \
                      <path d="M7.5 1v7h1V1z"/> \
                      <path d="M3 8.812a5 5 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812"/> \
                    </svg>',
    }).then((result) => {
      if (result.isConfirmed) {
        logOut();
        navigate(AppRoutes.login);
        return;
      }
    })
  };

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >

      {/* Main Content Area - Split Panel */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          overflow: 'hidden',
        }}
      >
        {/* Left Panel - Dark Blue (1/3 width) */}
        <Box
          sx={{
            width: '33.33%',
            backgroundImage: 'url(/assets/Brand/Login.png)',
            backgroundSize: '300% 100%',
            backgroundPosition: 'left',
            backgroundRepeat: 'no-repeat',
            backgroundColor: '#1e3a5f',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-end',
            position: 'relative',
            padding: '3%',
          }}
        >
          {/* Black gradient overlay for top 50% */}
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              height: 'calc(50% + 150px)',
              width: '100%',
              left: 0,
              background: 'linear-gradient(to top, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0))',
              zIndex: 1,
              pointerEvents: 'none',
            }}
          />
          {/* Welcome Message - Centered */}
          {/* <Typography
            sx={{
              fontSize: '36px',
              fontWeight: 400,
              color: 'white',
              fontFamily: "'Proxima Nova', sans-serif",
              textAlign: 'end',
              lineHeight: 1.2,
              ml: 8,
              position: 'relative',
              zIndex: 2,
            }}
          >
            Welcome to the<br />
            MISC Client<br />
            Portal
          </Typography> */}
          <Box
            component="img"
            src="/assets/brand/Welcome_to_the_MISC_Client_Portal.png"
            alt="MISC Logo"
            sx={{
              height: 'auto',
              width: '90%',
              zIndex: 1,
            }}
            onError={(e) => {
              // Fallback if image doesn't exist
              const target = e.target as HTMLImageElement;
              target.style.display = 'none';
            }}
          />

          {/* Logo at bottom left */}
          <Box
            sx={{
              position: 'absolute',
              bottom: '10px',
              right: '30px',
              display: 'flex',
              justifyContent: 'flex-end',
              zIndex: 2,
            }}
          >
            <Box
              component="img"
              src="/assets/brand/MISC_Small_Brand.png"
              alt="MISC Logo"
              sx={{
                height: 'auto',
                width: '40%',
              }}
              onError={(e) => {
                // Fallback if image doesn't exist
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
              }}
            />
          </Box>
        </Box>

        {/* Right Panel - White (2/3 width) */}
        <Box
          sx={{
            width: '66.67%',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            backgroundColor: '#f5f5f5',
          }}
        >
          {/* Navigation Icons - Top Right (Black icons) */}
          <Box
            sx={{
              // position: 'absolute',
              // top: '24px',
              // right: '24px',
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 1,
              padding: '20px 70px',
              // zIndex: 10,
            }}
          >
            <IconButton
              onClick={handleHomeClick}
              sx={{
                fill: '#000000',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
              }}
            >
              <HomeIcon />
            </IconButton>
            <IconButton
              onClick={toggleRightNav}
              sx={{
                color: '#000000',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
              }}
            >
              <MenuIcon sx={{ fontSize: 24 }} />
            </IconButton>
            <IconButton
              onClick={handleProfileClick}
              sx={{
                color: '#000000',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
              }}
            >
              <PersonIcon sx={{ fontSize: 24 }} />
            </IconButton>
          </Box>
            <CustomerHomeRightNav Open={showRightNav} handleClose={toggleRightNav} />
          {/* Content Area - Outlet for child routes */}
          <Box
            sx={{
              backgroundColor: '#f5f5f5',
              padding: '0 24px',
              flex: 1, // Take remaining space
              minHeight: 0, // Important for flex scrolling
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: '100%',
              overflow: 'auto',
            }}
          >
            {/* Spacer for vertical centering when content is small */}
            <Box sx={{ flex: '1 1 auto', minHeight: 0, display: 'flex', alignItems: 'center' }}>
              <Box
                sx={{
                  mx: 'auto',
                  py: { xs: 2, sm: 4 }, // Add vertical padding for spacing
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  '@media (max-height: 900px)': {
                    alignItems: 'flex-start',
                  },
                }}
              >
                <Outlet />
              </Box>
            </Box>
            {/* Bottom spacer for vertical centering */}
            <Box sx={{ flex: '1 1 auto', minHeight: 0, maxHeight: '80px', }} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
